import actions from '@store/modules/reporting/actions';
import getters from '@store/modules/reporting/getters';
import mutations from '@store/modules/reporting/mutations';

const state = {
  generatingReport: false,
  multipleReportsDownloading: false,
  multipleReportsIsDownloading: false,
  reportNavCategories: [],
  reportProcessed: false,
  reportTypes: [],
  reportingStatus: '',
  reportingUserMessage: '',
  reportsDownloading: {},
  reportsHaveLoaded: false,
  reportsLoading: false,
  selectedReportType: 'All',
}

export const reporting = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
